export const delayDispatch = (
  dispatch: () => void,
  delayInMillis: number
): number => {
  return setTimeout(() => {
    dispatch();
  }, delayInMillis) as unknown as number;
};
